var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Pane, PaneFooter, Button, TextField, Row, Col, Modal, ModalFooter, Icon, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { createApiClient } from "../api/apiClientService";
import { fetchCurrentUser } from "../api/userService";
import { fetchOrganizationById } from "../api/organizationService";
import { useModal } from "../utils/useModal";
import { getErrorInfo } from "../utils/getErrorCode";
import { getApiClientErrorMessage } from "../utils/apiClientErrorMessage";
import useNavigation from "../hooks/useNavigation";
import ActionErrorModal from "../components/ActionErrorModal";
var ApiClientForm = function (_a) {
    var match = _a.match;
    var goToList = useNavigation(match.path).goToList;
    var intl = useIntl();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useModal(), isOpen = _b.isOpen, message = _b.message, openModal = _b.openModal, closeModal = _b.closeModal;
    var _c = React.useState(false), showSecretModal = _c[0], setShowSecretModal = _c[1];
    var _d = React.useState(""), secret = _d[0], setSecret = _d[1];
    var _e = React.useState(false), secretCopied = _e[0], setSecretCopied = _e[1];
    var schema = useMemo(function () {
        return z.object({
            clientId: z
                .string()
                .min(1, intl.formatMessage({
                id: "ui-czna-users.apiClients.form.clientId.required",
            }))
                .regex(/^[a-z][a-z0-9-]*$/, intl.formatMessage({
                id: "ui-czna-users.apiClients.form.clientId.pattern",
            })),
            name: z.string().min(1, intl.formatMessage({
                id: "ui-czna-users.apiClients.form.name.required",
            })),
            description: z.string(),
        });
    }, [intl]);
    var user = useQuery(["czna-users", "me"], function () { return fetchCurrentUser(ky); }, { staleTime: 5 * 60 * 1000 }).data;
    var organization = useQuery(["czna-organizations", user === null || user === void 0 ? void 0 : user.organizationId], function () { return fetchOrganizationById(ky, user.organizationId); }, { enabled: !!(user === null || user === void 0 ? void 0 : user.organizationId) }).data;
    var _f = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            clientId: "",
            name: "",
            description: "",
        },
        mode: "onBlur",
        shouldFocusError: false,
    }), handleSubmit = _f.handleSubmit, control = _f.control, reset = _f.reset, _g = _f.formState, errors = _g.errors, isSubmitting = _g.isSubmitting, isDirty = _g.isDirty;
    useEffect(function () {
        var _a, _b;
        if (organization) {
            var sigla = (_b = (_a = organization.sigla) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
            reset({
                clientId: sigla ? "".concat(sigla, "-import-client") : "",
                name: "".concat(organization.name, " \u2014 import"),
                description: "",
            });
        }
    }, [organization, reset]);
    var saveMutation = useMutation(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var description, rest, payload;
        return __generator(this, function (_a) {
            description = values.description, rest = __rest(values, ["description"]);
            payload = __assign(__assign({}, rest), (description ? { description: description } : {}));
            return [2 /*return*/, createApiClient(ky, payload)];
        });
    }); }, {
        onSuccess: function (data) {
            queryClient.invalidateQueries(["czna-api-clients"]);
            setSecret(data.clientSecret);
            setSecretCopied(false);
            setShowSecretModal(true);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(error)];
                    case 1:
                        errorInfo = _a.sent();
                        if (errorInfo.status === 409) {
                            openModal(intl.formatMessage({
                                id: "ui-czna-users.apiClients.error.conflict",
                            }));
                        }
                        else {
                            openModal(getApiClientErrorMessage(errorInfo, intl));
                        }
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleClose = function () {
        goToList();
    };
    var onSubmit = function (values) {
        saveMutation.mutate(values);
    };
    var handleCopySecret = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(secret)];
                case 1:
                    _b.sent();
                    setSecretCopied(true);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSecretModalClose = function () {
        setShowSecretModal(false);
        goToList();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.new" }), onClose: handleClose, dismissible: true, footer: React.createElement(PaneFooter, { renderEnd: React.createElement(React.Fragment, null,
                        React.createElement(Button, { marginBottom0: true, onClick: handleClose },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.cancel" })),
                        React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: !isDirty || isSubmitting },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.save" }))) }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "clientId", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.clientId" }), placeholder: intl.formatMessage({
                                        id: "ui-czna-users.apiClients.form.clientId.hint",
                                    }), error: (_b = errors.clientId) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                            } })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.name" }), placeholder: intl.formatMessage({
                                        id: "ui-czna-users.apiClients.form.name.hint",
                                    }), error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                            } }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Controller, { control: control, name: "description", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.description" }), placeholder: intl.formatMessage({
                                        id: "ui-czna-users.apiClients.form.description.hint",
                                    }), error: (_b = errors.description) === null || _b === void 0 ? void 0 : _b.message })));
                            } }))))),
        React.createElement(Modal, { open: showSecretModal, label: intl.formatMessage({
                id: "ui-czna-users.apiClients.secret.title",
            }), dismissible: true, onClose: handleSecretModalClose, footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { onClick: handleSecretModalClose },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.cancel" }))) },
            React.createElement("p", { style: { color: "#d00", fontWeight: "bold" } },
                React.createElement(FormattedMessage, { id: "ui-czna-users.apiClients.secret.warning" })),
            React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    marginTop: "1rem",
                } },
                React.createElement("code", { style: {
                        flex: 1,
                        padding: "0.75rem",
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontFamily: "monospace",
                        fontSize: "0.9rem",
                        wordBreak: "break-all",
                    } }, secret),
                React.createElement(Button, { buttonStyle: "default", onClick: handleCopySecret },
                    React.createElement(Icon, { icon: "clipboard" }, secretCopied ? "✓" : "Copy")))),
        React.createElement(ActionErrorModal, { open: isOpen, message: message, onClose: closeModal })));
};
export default ApiClientForm;
